module.exports = __webpack_public_path__ + "static/media/user-guide.a42d3440.pdf";